import React, { Component, Fragment } from 'react';
import styled from 'styled-components';

import { getTheme } from '../../util/theme';

const DialogContent = styled.div`
  background-color: #fff;
  bottom: 0;
  display: none;
  left: 0;
  height: 90%;
  margin: auto;
  max-width: 480px;
  overflow-y: auto;
  padding: ${getTheme('doubleSpace')};
  position: fixed;
  right: 0;
  top: 0;
  width: 90%;
  z-index: 3;

  &.active {
    animation: display-modal-content 0.33s ease-out forwards;
    display: block;
  }

  &.inactive {
    animation: hide-modal-content 0.33s ease-out forwards;
  }

  .dialog__close {
    border: none;
    font-size: 2rem;
    position: absolute;
    right: 0.375rem;
    top: 0.375rem;
  }
`;

const DialogOverlay = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  display: none;
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 2;

  &.active {
    animation: display-modal-overlay 0.33s ease-out forwards;
    display: block;
  }

  &.inactive {
    animation: hide-modal-overlay 0.33s ease-out forwards;
    display: block;
    pointer-events: none;
  }
`;

export class Dialog extends Component {
  open = () => {
    const dialog = document.querySelector('.dialog');
    const overlay = document.querySelector('.dialog-overlay');

    dialog.removeAttribute('aria-hidden');
    overlay.removeAttribute('aria-hidden');

    dialog.classList.remove('inactive');
    overlay.classList.remove('inactive');

    dialog.classList.add('active');
    overlay.classList.add('active');

    overlay.addEventListener('click', () => {
      this.close();
    });
  };

  close = () => {
    const dialog = document.querySelector('.dialog');
    const overlay = document.querySelector('.dialog-overlay');
    const focusedElBeforeOpen = document.activeElement;

    dialog.setAttribute('aria-hidden', true);
    overlay.setAttribute('aria-hidden', true);

    dialog.classList.remove('active');
    overlay.classList.remove('active');

    dialog.classList.add('inactive');
    overlay.classList.add('inactive');

    if (focusedElBeforeOpen) {
      focusedElBeforeOpen.focus();
    }
  };

  componentDidMount() {
    const { open } = this.props;

    if (!open) {
      this.close();
    } else {
      this.open();
    }
  }

  componentDidUpdate(prevProps) {
    const { open } = this.props;

    if (open !== prevProps.open) {
      if (!open) {
        this.close();
      } else {
        this.open();
      }
    }
  }

  render() {
    const { children, close } = this.props;

    return (
      <Fragment>
        <DialogContent
          className="dialog"
          role="dialog"
          aria-labelledby="dialog-title"
          aria-describedby="dialog-description"
        >
          <button
            aria-label="Close Advanced Search Form dialog"
            className="dialog__close"
            onClick={close}
          >
            &times;
          </button>
          {children}
        </DialogContent>
        <DialogOverlay className="dialog-overlay">&nbsp;</DialogOverlay>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Shared/Dialog.js